import React, { useEffect, useMemo, useRef, useState } from "react";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import PropTypes from "prop-types";
import {
  Box,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Typography,
  Paper,
  Checkbox,
  IconButton,
  Fade,
  CircularProgress,
  Button,
  Popover,
  Tooltip,
  Skeleton,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
// import FilterAltIcon from "@mui/icons-material/FilterAlt";
import {
  Clear,
  CommitSharp,
  GroupWork,
  Add,
  Edit,
  Delete,
  Cloud,
  CloudDone,
  DirectionsRun,
  Accessibility,
  CheckCircleOutline,
  DoDisturbAlt,
  ArrowCircleRight,
} from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { display } from "../../redux/reducers/sidebar";
import ConfirmDeleteModal from "../../components/modals/ConfirmDeleteModal";
import { API, graphqlOperation } from "aws-amplify";
import { useLocation } from "react-router-dom";
import MuiAlert from "@mui/material/Alert";
import { ThreeDot } from "../../components/DropDown/ThreeDot";
import {
  deleteAccountGroupMaster,
  updateAccountGroupMaster,
} from "../../graphql/mutations";
import {
  showErrorSnackbar,
  showSuccessSnackbar,
  showWarningSnackbar,
} from "../../components/snackBar/snakbar";
import moment from "moment/moment";
import DeleteLedgerGroup from "../../components/modals/DeleteLedgerGroup";
import DropDownForListing from "../../components/DropDown/DropDown";
import DeleteSelectedGroup from "../../components/modals/DeleteSelectedGroup";
import { ListSelection_fnForMasters } from "../../library/ListSelection";
import { listAccountGroupMasterCustom } from "../../graphql";
import CreateAndEditGroupModal from "../../components/modals/CreateAndEditGroupModal";
import { useSelector } from "react-redux";
import {
  defaultRowsPerPage,
  defaultRowsPerPageOptions,
  handleFreeze,
} from "../../utils/common";
import ListingActive from "../../components/modals/ListingActive";
import { settingsClose } from "../../redux/reducers/companySkipSave";
import { useThemes } from "../../components/Theme/theme";
import {
  useDeleteAccountGroupMasterMutation,
  useUpdateAccountGroupMasterMutation,
  useListGroupMasterQuery,
} from "../../redux/apis/accountGroupMaster.api";
import TableSearchButton from "../PrimeFigma/Components/TableSearchButton";
import { TableCell } from "../../components/Table/TableCell";
import { globalColors } from "../../App";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const headCell = [
  {
    id: "AccountGroupName",
    numeric: false,
    disablePadding: false,
    label: "Group Name",
    width: "130px",
  },
  {
    id: "AccountTypeCD",
    numeric: false,
    disablePadding: false,
    label: "Type",
    width: "170px",
  },
  {
    id: "EnteredTimeStamp",
    numeric: false,
    disablePadding: false,
    label: "Created Date",
    width: "130px",
  },
  {
    id: "Action",
    numeric: false,
    disablePadding: false,
    label: "Actions",
    width: "100px",
  },
];

function EnhancedTableHead(props) {
  const { theme } = useThemes();

  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    onDelete,
    setEnableSearch,
    showActions,
    scroll,
    setShowActions
  } = props;
  const [headCellSettings, setHeadCellSettings] = useState(headCell);

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  let getCompany = useSelector(
    (state) => state?.companyReducer?.companyDetails
  );

  async function getCompanyDetails() {
    try {
      let nonGstHeadCell = [];
      if (getCompany?.relatedCompanyDetailsNew?.[0]?.RegistrationType == 1) {
        nonGstHeadCell = headCell.filter((ele, key) => {
          if (ele?.id !== "GSTCategory" && ele?.id !== "GSTIN") {
            return ele;
          }
        });
        setHeadCellSettings(nonGstHeadCell);
      }
    } catch (error) {
      console.log("error", error);
    }
  }
  useEffect(() => {
    getCompanyDetails();
  }, []);
  const Freeze = useSelector(
    (state) => state.userPrefrenceandReducer?.financialYear?.freezestatus
  );

  return (
    <TableRow
      className="tableCustomHead"
      sx={{
        backgroundColor: "background.tablebg",
        ".MuiTableCell-root": {
          backgroundColor: `${theme.palette.background.tablebg} !important`,
        },
        ".MuiTableCell-head": {
          backgroundColor: "background.tablebg",
          top: 0,
          zIndex: 2,
        },
        '& .MuiCheckbox-root': {
          padding: '4px',
        },
        height: "35px"
      }}
    >
      <TableCell
      // padding="checkbox"
      // sx={{
      //   ".css-1mqsplk-MuiButtonBase-root-MuiCheckbox-root": {
      //     padding: "5px",
      //   },
      // }}
      >
        <Checkbox
          sx={{ color: "input.border" }}
          indeterminate={numSelected > 0 && numSelected < rowCount}
          checked={rowCount > 0 && numSelected === rowCount}
          onChange={onSelectAllClick}
          inputProps={{
            "aria-label": "select all desserts",
          }}
          size="small"
        />
      </TableCell>
      {headCellSettings.map((headCell) => (
        <TableCell
          key={headCell.id}
          align={headCell.numeric ? "right" : "left"}
          padding={headCell.disablePadding ? "none" : "normal"}
          sortDirection={orderBy === headCell.id ? order : false}
          sx={{
            minWidth: headCell.width,
            position: headCell.id === "Action" ? "sticky" : "",
            right: headCell.id === "Action" ? 0 : "",
            // borderLeft: headCell.id === "Action" ? "1px solid" : "0px",
             "&:focus, &:active, &:focus-visible": {
        outline: "none !important",
        border: "none !important",
        boxShadow: "none !important",
      },
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent:headCell.id === "Action" ? "center" : 'space-between',
              alignItems: "center",
              borderRadius:headCell.id === "Action" ? "3px" : "",
              width:"100%",
              backgroundColor:headCell.id === "Action" ? "white" : 'background.tablebg',
              boxShadow: (headCell.id === "Action") && (scroll) ?  "0px 4px 8px rgba(0, 0, 0, 0.6)" : "",
                 "&:active": 
                {
                  transform: scroll ? "scale(0.92)":"scale(1)",
                },
            }}
            onClick={(e) => {
              if(headCell.label === 'Actions'){
                setShowActions((pre) => !pre)  
              } else if(headCell.id !== 'Action') {
                createSortHandler(headCell.id)(e);
              }
            }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={
                headCell.id !== "Action" ? createSortHandler(headCell.id) : null
              }
              hideSortIcon={headCell.id === "Action"}
            >
             {headCell.id != 'Action' ? (
                <>
                    <Box sx={{ display: 'flex' }}>
                      <Box sx={{ whiteSpace: 'nowrap' }}>{headCell.label}</Box>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {orderBy === headCell.id ? (
                          <Box
                            //  component="span"
                            sx={visuallyHidden}
                          >
                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                          </Box>
                        ) : null}
                        {/* {headCell.id !== "Action" ? (
                          <SearchIcon
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setEnableSearch((prev) => !prev);
                            }}
                            sx={{ marginLeft: "10px" }}
                            fontSize="small"
                          />
                        ) : null} */}
                      </Box>
                    </Box>
                  {/* <IconButton sx={{ margin: '0px 2px', padding: '5px', }}>
                    <FilterAltIcon fontSize='small' sx={{ color: 'primary.main' }} />
                  </IconButton> */}
                </>
              ) : (
                <Box 
                  sx={{
                    display:"flex",
                    alignItems:"center",
                    backgroundColor:headCell.id === "Action" ? "white" : 'background.tablebg',
                    }}
                  >
                    {headCell.label}
                    {
                      (headCell.id === "Action") && (scroll) ? 
                      <ArrowCircleRight
                        sx={{
                         transition: 'transform 0.3s ease-in-out',
                         marginLeft: '10px',
                         transform : !showActions ?  'rotate(180deg)' : 'rotate(0deg)',
                         color:!showActions ? 'gray' : '#ee5b2b',
                        }}
                        fontSize="small"
                    />  : 
                    null
                    }
                      
                </Box>
              )}
            </TableSortLabel>
          </Box>
        </TableCell>
      ))}
      {numSelected > 0 ? (
        <TableCell>
          <ThreeDot
            onDelete={() => {
              if (Freeze === 1) {
                return handleFreeze();
              }
              onDelete(true);
            }}
          />
        </TableCell>
      ) : null}
    </TableRow>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function AllGroups() {
  const { theme } = useThemes();
  const location = useLocation();
  const dispatch = useDispatch();
  dispatch(display());
  const { saveSkipStatus } = useSelector(
    (state) => state.companySipSaveReducer
  );
  const [newId, setNewId] = useState();
  const navigate = useNavigate();
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("AccountGroupName");
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage);
  const [deleteModalStatus, setDeleteModalStatus] = useState(false);
  const [groupOpen, setGroupOpen] = useState(false);
  const [filteredList, setFilteredList] = useState([]);
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [activeValueModal, setActiveValueModal] = useState();
  const [deleteSelectedModal, setDeleteSelectedModal] = useState(false);
  const defaultFilterColumns = {
    accountgroupname: "",
    accounttypecd: "",
    enteredtimestamps: "",
    accounttypecdshow: "",
  }
  const [filterColumns, setFilterColumns] = useState(defaultFilterColumns);
   const [showActions,setShowActions] = useState(true)
   const allGROUPref = useRef()

  const handleResetFilterColumns = (status) => {
    if (status === false) {
      setFilterColumns(defaultFilterColumns);
      filterBySearch({
        target: {
          value: "",
          name: ""
        }
      }, '')
    }
  }
  // State to manage the anchor element for the popover
  // const [allGroups, setAllGroups] = useState([]);
  const [gstStatus, setGstStatus] = useState("");


  useEffect(() => {
    const controlAndS = (e) => {
      const id = document.getElementById("companySetup")
      if (!groupOpen && !id) {
        if (e.ctrlKey && e.key.toLowerCase() === "s") {
          e.preventDefault();
          // showErrorSnackbar("Nothing to save");
        }
      }
    };

    window.addEventListener('keydown', controlAndS);

    return () => {
      window.removeEventListener('keydown', controlAndS);
    };
  }, [groupOpen]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked && filteredList.length) {
      const newSelected = filteredList.map((n) => n.accountgroupid);
      setSelected(newSelected);
      return;
    }
    setDeleteSelectedModal(false);
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - filteredList.length) : 0;
  // const [circularOpen, setCircularOpen] = useState(true);
  // const getGroupMaster = ()=>{};
  const { data: allGroups, isLoading: circularOpen } =
    useListGroupMasterQuery();

  const rows = useMemo(() => {
    return (
      allGroups?.map((elem) => ({
        ...elem,
        enteredtimestamps: moment(elem.enteredtimestamp * 1000).format(
          "DD-MM-yyyy"
        ),
        accounttypecdshow:
          elem.accounttypecd === "PandL"
            ? "Profit and Loss"
            : elem?.accounttypecd === "BS"
              ? "Balancesheet"
              : "",
        accounttypecd: elem.accounttypecd,
      })) || []
    );
  }, [allGroups]);
  const setAllGroups = () => { };
  const getGroupMaster = () => { };
  const setRows = () => { };
  const setCircularOpen = () => { };
  async function getGroupMasters(data) {
    try {
      Promise.all([null, data])
        .then((response) => {
          let res = response[1];
          let dres = response[0];
          let arr = [];
          let arrD = [];
          setAllGroups(res?.data?.listAccountGroupMaster);
          if (res.data.listAccountGroupMaster.sort().reverse() != null) {
            arr = res.data.listAccountGroupMaster.map((elem) => ({
              ...elem,
              enteredtimestamps: moment(elem.enteredtimestamp * 1000).format(
                "DD-MM-yyyy"
              ),
              accounttypecdshow:
                elem.accounttypecd === "PandL"
                  ? "Profit and Loss"
                  : elem?.accounttypecd === "BS"
                    ? "Balancesheet"
                    : "",
              accounttypecd: elem.accounttypecd,
            }));
          }
          if (dres?.data?.listDeletedAccountGroups?.sort().reverse() != null) {
            arrD = dres.data.listDeletedAccountGroups.map((elem) => ({
              ...elem,
              enteredtimestamps: moment(elem.enteredtimestamp * 1000).format(
                "DD-MM-yyyy"
              ),
              accounttypecdshow:
                elem.accounttypecd === "PandL"
                  ? "Profit and Loss"
                  : elem?.accounttypecd === "BS"
                    ? "Balancesheet"
                    : "",
              accounttypecd: elem.accounttypecd,
            }));
          }
          setRows([...arr, ...arrD]);
        })
        .finally(() => {
          setBackdropOpen(false);
          setCircularOpen(false);
        });
    } catch (error) {
      console.log(error);
    }
  }
  let params = location.state;
  useEffect(() => {
    setBackdropOpen(true);
    getGroupMaster();
    getCompanyDetails();
    if (params?.add) {
      setGroupOpen(true);
      navigate("/groups"); //while reload we doesn't want to open the modal
    }
  }, []);

  const filterBySearch = (event, category) => {
    setPage(0);
    const query = event?.target?.value;
    const name = event?.target?.name;
    if (name) {
    const obj = { ...filterColumns };
      for (const key in obj) {
        if (key == name) {
          obj[key] = query;
        } else {
          obj[key] = "";
        }
      }
      setFilterColumns(obj);
    }
    var updatedList = [...rows];
    if (query !== "") {
      updatedList = updatedList.filter((item) => {
        if (item[category] !== undefined && item[category] !== null) {
          return (
            item[category]
              .toString()
              .toLowerCase()
              .indexOf(query.toLowerCase()) !== -1
          );
        }
      });
      setFilteredList(updatedList);
    } else {
      setFilteredList(rows);
    }
  };

  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setdeleteId] = useState("");
  const [selectedRow, setSelectedRow] = useState([]);

  const [deleteAccountGroupMaster] = useDeleteAccountGroupMasterMutation();

  async function deleteAccounts() {
    try {
      const resDeleteLedger = await deleteAccountGroupMaster({
        accountgroupid: deleteId.id,
      });
      if (resDeleteLedger.data) {
        getGroupMaster();
        setBackdropOpen(false);
      }
      if (resDeleteLedger?.data?.statuscode === "Error") {
        setBackdropOpen(false);
        showErrorSnackbar(resDeleteLedger?.data?.statusmessage);
      } else {
        showSuccessSnackbar("Group Deleted");
        setBackdropOpen(false);
      }
    } catch (e) {
      console.log(e);
    }
  }

  useEffect(() => {
    if (deleteId !== "") {
      deleteAccounts();
      setdeleteId("");
    }
  }, [deleteId]);

  useEffect(() => {
    setFilteredList(rows);
  }, [rows]);
  let getCompany = useSelector(
    (state) => state?.companyReducer?.companyDetails
  );

  async function getCompanyDetails() {
    try {
      setGstStatus(getCompany.relatedcompanydetailsnew[0].registrationtype);
    } catch (error) {
      console.log("error", error);
    }
  }

  function getComparator(order, orderBy) {
    console.log(orderBy, "!!orderby");

    return (a, b) => {
      const valueA = a[orderBy];
      const valueB = b[orderBy];

      console.log({ valueA, valueB })

      if (!isNaN(valueA) && !isNaN(valueB)) {
        return order === "asc" ? valueA - valueB : valueB - valueA;
      }

      const strA = typeof valueA === "string" ? valueA.toLowerCase() : "";
      const strB = typeof valueB === "string" ? valueB.toLowerCase() : "";

      return order === "asc" ? strA.localeCompare(strB) : strB.localeCompare(strA);
    };
  }

  function sortArrayByKey(array, key) {
    // Map header IDs to actual data property names
    const keyMapping = {
      'AccountGroupName': 'accountgroupname',
      'AccountTypeCD': 'accounttypecdshow',
      'EnteredTimeStamp': 'enteredtimestamps'
    };
    
    const actualKey = keyMapping[key] || key.toLowerCase();
    
    if (order === "asc") {
      return array.sort((b, a) => {
        if (a[actualKey] > b[actualKey]) return -1;
        if (a[actualKey] < b[actualKey]) return 1;
        return 0;
      });
    } else {
      return array.sort((b, a) => {
        if (a[actualKey] < b[actualKey]) return -1;
        if (a[actualKey] > b[actualKey]) return 1;
        return 0;
      });
    }
  }

  const [updateAccountGroupMaster] = useUpdateAccountGroupMasterMutation();

  const markAsInActive = async (data, index) => {
    try {
      let masterData = {
        accountgroupname: data.accountgroupname,
        accountparentgroupid: data?.accountparentgroupid,
        accounttypecd: data?.accounttypecd,
        accountgroupid: data?.accountgroupid,
        companybranchid: data?.companybranchid || 0,
        is_active: data.is_active ? 0 : 1,
      };
      let response = await updateAccountGroupMaster({
        updateAccountGroupMasterInput: masterData,
      });
      showSuccessSnackbar(
        `Group marked as ${data.is_active ? "inactive" : "active"} !`
      );
      getGroupMaster();
    } catch (error) {
      console.log(error);
    }
  };
  const [ListSelection, setListSelection] = useState("All");
  const [EnableSearch, setEnableSearch] = useState(false);

    const [scroll,setScroll] = useState(false)
      useEffect(() => {
      if (filteredList.length > 0 && circularOpen) {
        const width = allGROUPref.current?.offsetWidth;
        const screenWidth = window.innerWidth;
        if (width < screenWidth) {
        setScroll(false)
        } else {
          setScroll(true);
        }
      }
    }, [filteredList, circularOpen]);

  const Freeze = useSelector(
    (state) => state.userPrefrenceandReducer?.financialYear?.freezestatus
  );

  return (
    <Box>
      <ConfirmDeleteModal
        open={deleteModalStatus}
        setOpen={setDeleteModalStatus}
      />

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderTopRightRadius: "12px",
          borderTopLeftRadius: "12px",
          padding: "8px 10px",
          backgroundColor: "primary.main",
          // marginBottom:'20px'
        }}
      >
        <Box
          sx={{
            display: "flex",
            flex: { xs: 1, sm: 0 },
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex" }}>
            {/* <Link className="link-thex link-the" to={"/accounts"}>
              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: { sm: "10px 16px", xs: "10px 10px" },
                  backgroundColor: "primary.main",
                  borderRadius: "6px",
                  cursor: "pointer",
                  color: "white",
                  margin: "0px 5px",
                  transition: "ease-in-out .4",
                  ":hover": {
                    backgroundColor: "primary.main",
                    color: "#f1ededeb",
                  },
                }}
              // onClick={() => navigate('/goodslist')}
              >
                <CommitSharp
                  sx={{
                    fontSize: "20px",
                    display: { xs: "none", sm: "block" },
                  }}
                />
                <Typography
                  sx={{
                    color: "white",
                    ":hover": {
                      backgroundColor: "primary.main",
                      color: "#f1ededeb",
                    },
                    fontSize: "12px",
                    marginLeft: { sm: "5px", xs: "0" },
                  }}
                >
                  Ledgers
                </Typography>
              </Box>
            </Link>
            <Link className="link-thex link-the" to={"/groups"}>
              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: { sm: "10px 16px", xs: "10px 10px" },
                  backgroundColor: "white",
                  borderRadius: "6px",
                  cursor: "pointer",
                  color: "primary.main",
                  transition: "ease-in-out .4",
                }}
                onClick={() => {
                  navigate("/groups");
                }}
              >
                <GroupWork
                  sx={{
                    fontSize: "20px",
                    display: { xs: "none", sm: "block" },
                  }}
                />
                <Typography
                  sx={{
                    fontSize: "12px",
                    color: "primary.main",
                    marginLeft: { sm: "5px", xs: "0" },
                  }}
                >
                  Groups
                </Typography>
              </Box>
            </Link> */}

             <FormControl size="small"
                sx={{
                  minWidth:{xs:100,sx: 160},
                  backgroundColor: "white",
                  borderRadius: "6px",
                  boxShadow: 1,
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  "& .MuiSelect-icon": {
                    color: globalColors.primary, 
                  },
                }}>
               <Select
                    displayEmpty
                    value=""
                    renderValue={(selected) => {
                      if (selected === "") {
                        return <span style={{ color:globalColors.primary}}>Groups</span>;
                      }
                      return selected;
                    }}
                    onChange={()=> navigate("/accounts")}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          backgroundColor: "white",
                          boxShadow: 3,
                        },
                      },
                    }}
                >
                  <MenuItem 
                      sx={{color:globalColors.primary, 
                        "&:hover": { backgroundColor: "white" }, 
                        "&.Mui-focusVisible": {
                          backgroundColor: "transparent", 
                        },
                    }}
                  >
                    Ledgers
                  </MenuItem>  
                </Select>
            </FormControl>
          </Box>
          <Button
            sx={{
              whiteSpace: "nowrap",
              border: "1px solid white",
              boxShadow: "0px 6px 8px rgba(0, 0, 0, 0.5)",
              ml: 1,
              fontWeight: "bold",
              backgroundColor: "white",
              "&:hover": {
                backgroundColor: "white", // Override hover background color
              },
            }}
            variant="outlined"
            startIcon={<Add />}
            onClick={(e) => {
              if (Freeze == 1) {
                return handleFreeze();
              }
              if (saveSkipStatus == false) {
                if (window.location.href.includes("companysetup")) {
                  showWarningSnackbar(
                    "Please Complete the Company Setup Details"
                  );
                }
                e.preventDefault();
                dispatch(settingsClose());
                navigate("/companysetup");
              }
              setGroupOpen(true);
            }}
          >
            Add Group
          </Button>
          <Box sx={{display:{xs:'flex',sm:'none',justifyContent:'center',alignItems:'center'}}}>
            <TableSearchButton
            setEnableSearch={setEnableSearch}
            EnableSearch={EnableSearch}
            id={'accountsSearch'}
            onClick={handleResetFilterColumns}
            />
          </Box>
          {/* <button onClick={invalidate}>invalidate</button> */}
          {/* <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              padding: "10px 16px",
              backgroundColor: "primary.main",
              borderRadius: "6px",
              cursor: "pointer",
              color: "#fff",
              margin: "0px 5px",
              transition: "ease-in-out .4",
              ":hover": {
                backgroundColor: "primary.main",
                color: "#f1ededeb",
              },
            }}
            onClick={() => navigate("/supplierList")}
          >
            <BusinessCenter sx={{ fontSize: "20px" }} />
            <Typography sx={{ fontSize: "12px", marginLeft: "5px" }}>
              Suppliers
            </Typography>
          </Box> */}
        </Box>

        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box sx={{display:{xs:'none',sm:'block'}}}>
            <TableSearchButton
            setEnableSearch={setEnableSearch}
            EnableSearch={EnableSearch}
            id={'accountsSearch'}
            onClick={handleResetFilterColumns}
            />
          </Box>
          <Box
            sx={{
              display: {
                xs: "none",
                sm: "flex",
                md: "flex",
                lg: "flex",
                xl: "flex",
              },
            }}
          >
            <Typography
              sx={{
                display: "flex",
                alignItems: "center",
                fontSize: "13px",
                color: "white",
              }}
            >
              Total : {rows.length} Item{rows.length !== 1 && "s"}{" "}
              {selected.length != 0
                ? `(Selected: ${selected.length}/${rows.length})`
                : ""}
            </Typography>
            <DropDownForListing
              name={"ser"}
              list={[
                { label: "All", value: "All" },
                { label: "Active", value: "Active" },
                { label: "In-Active", value: "InActive" },
              ]}
              value={ListSelection}
              onChange={(e) => {
                setListSelection(e.target.value);
                setPage(0);
              }}
            />
          </Box>
        </Box>


      </Box>

      <Box
        sx={{
          // boxShadow: "inset 0 0 8px #d7d7d73b",
          boxShadow: "rgb(33 35 38 / 10%) 0px 10px 10px -10px",
          borderBottomRightRadius: "12px",
          borderBottomLeftRadius: "12px",
          // backgroundColor: theme.palette.bodyGray.secondary,
          // borderRadius:'12px',
          padding: {
            // xs: "8px 12px",
          },
          ".css-1mxz8qt-MuiPaper-root": {
            boxShadow: "none",
          },
          ".MuiTableCell-root": {
            padding: "0px 10px",
            fontSize: "13px",
          },
          ".MuiTableCell-head": {
            backgroundColor: "background.tablebg",
            padding: "0px 10px",
            borderBottom: "0px",
          },
        }}
      >
        <Box sx={{ width: "100%", overflow: "hidden", boxShadow: "none" }}>
          <TableContainer
            className="custom-scrollbar"
            sx={{
              height: {
                sm: "calc( 100vh - 230px )",
                xs: "calc( 100vh - 180px )",
              },
            }}
          >
            <Table
              stickyHeader
              aria-label="sticky table"
              sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              size={dense ? "small" : "medium"}
            >
              <TableHead>
                <EnhancedTableHead
                  EnableSearch={EnableSearch}
                  setEnableSearch={setEnableSearch}
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={rows.length}
                  onDelete={() => setDeleteSelectedModal(true)}
                  setShowActions = {setShowActions}
                  showActions = {showActions}
                  scroll = {scroll}
                />

              </TableHead>

              <TableBody
                sx={{
                  ".MuiTableCell-root": {
                    backgroundColor: "transparent ",
                  },
                }}
                ref = {allGROUPref}
              >

                {EnableSearch == true && (
                  <TableRow
                    sx={{
                      "& .MuiTableCell-head": {
                        backgroundColor: "background.tablebg",
                        top: 38,
                        zIndex: 1,
                      },
                      ".MuiTableCell-root": {
                        backgroundColor: "transparent !important",
                        padding: "1px 10px",
                        fontSize: "13px",
                      },
                      ".css-wrnu0i-MuiInputBase-root": {
                        fontSize: "13px",
                      },
                      ".css-xk0adg-MuiButtonBase-root-MuiIconButton-root": {
                        padding: "2px 4px",
                      },
                      ".css-1gqfvv-MuiPaper-root": {
                        boxShadow: "none",
                        borderBottom: "solid 1px rgba(0,0,0,0.24)",
                        borderRadius: "0px",
                      },
                      '& .MuiCheckbox-root': {
                        padding: '4px',
                      },
                    }}
                  >
                    <TableCell></TableCell>

                    <TableCell>
                      <Paper
                        id="groupSearch"
                        sx={{
                          p: "2px 4px",
                          display: "flex",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <InputBase
                          name="accountgroupname"
                          value={filterColumns.accountgroupname}
                          onChange={(e) =>
                            filterBySearch(e, "accountgroupname")
                          }
                          sx={{ flex: 1 }}
                          placeholder="Search"
                          autoComplete="off"
                        />
                        <IconButton type="button" sx={{ padding: "0px", }}>
                          {filterColumns.accountgroupname !== "" ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  accountgroupname: "",
                                }));
                                setFilteredList(rows);
                              }}
                            />
                          ) : (
                            <SearchIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Paper>
                    </TableCell>
                    <TableCell>
                      <Paper
                        sx={{
                          p: "2px 4px",
                          display: "flex",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <InputBase
                          name="accounttypecdshow"
                          value={filterColumns.accounttypecdshow}
                          onChange={(e) =>
                            filterBySearch(e, "accounttypecdshow")
                          }
                          sx={{ flex: 1 }}
                          placeholder="Search"
                          autoComplete="off"
                        />
                        <IconButton type="button" sx={{ padding: "0px" }}>
                          {filterColumns.accounttypecdshow !== "" ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  accounttypecdshow: "",
                                }));
                                setFilteredList(rows);
                              }}
                            />
                          ) : (
                            <SearchIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Paper>
                    </TableCell>
                    <TableCell>
                      <Paper
                        sx={{
                          p: "2px 4px",
                          display: "flex",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <InputBase
                          name="enteredtimestamps"
                          value={filterColumns.enteredtimestamps}
                          onChange={(e) =>
                            filterBySearch(e, "enteredtimestamps")
                          }
                          sx={{ flex: 1 }}
                          placeholder="Search"
                          autoComplete="off"
                        />
                        <IconButton type="button" sx={{ padding: "0px" }}>
                          {filterColumns.enteredtimestamps !== "" ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  enteredtimestamps: "",
                                }));
                                setFilteredList(rows);
                              }}
                            />
                          ) : (
                            <SearchIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Paper>
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                )}
                {filteredList.length > 0 ? (
                  sortArrayByKey(filteredList, orderBy)
                    .sort((a, b) => {
                      const aIsNew = a.accountgroupid === newId
                      const bIsNew = b.accountgroupid === newId

                      if (aIsNew && !bIsNew) return -1;
                      if (!aIsNew && bIsNew) return 1;

                      return getComparator(order, orderBy)(a, b);
                    })
                    // .sort(getComparator(order, orderBy))
                    .filter((e) => ListSelection_fnForMasters(e, ListSelection))
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      const isItemSelected = isSelected(row.accountgroupid);
                      const labelId = `enhanced-table-checkbox-${index}`;

                      return (
                        <TableRow
                          className={`noTableCellBorder ${!row.is_active ? 'rowInactiveMuted' : ''}`}
                          hover
                          onClick={(event) => { }}
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={index}
                          selected={isItemSelected}
                          style={{ cursor: "pointer" }}
                          sx={{
                            ".MuiTableCell-root": {
                              backgroundColor: "transparent ",
                              borderBottom:"none"
                            },
                            '& .MuiCheckbox-root': {
                              padding: '4px',
                            },
                          }}
                        >
                          <TableCell
                            padding="checkbox"
                            sx={{
                              ".css-1mqsplk-MuiButtonBase-root-MuiCheckbox-root":
                              {
                                padding: "5px",
                              },
                            }}
                            title={row.is_active === 1 ? "" : "Inactive"}
                          >
                            <Checkbox
                              onClick={(event) => {
                                event.stopPropagation();
                                handleClick(event, row.accountgroupid);
                              }}
                              color="primary"
                              checked={isItemSelected}
                              inputProps={{
                                "aria-labelledby": labelId,
                              }}
                              size="small"
                            />
                          </TableCell>

                          <TableCell
                            align="left"
                            sx={{
                              // height: "40px",
                              // display: "flex",
                              // alignItems: "center",
                            }}
                            title={row.is_active === 1 ? "" : "Inactive"}
                          >
                            <> {row.accountgroupname}</>
                            {row.accountgroupid == newId && (
                              <Box
                                sx={{
                                  backgroundColor: "#FF004D",
                                  color: "#FFF",
                                  borderRadius: 10,
                                  marginLeft: 1.5,
                                  fontSize: 10,
                                  paddingLeft: 2,
                                  paddingRight: 2,
                                  paddingTop: 0.25,
                                  paddingBottom: 0.25,
                                  display:'inline'
                                }}
                              >
                                New
                              </Box>
                            )}
                          </TableCell>
                          <TableCell
                            align="left"
                            title={row.is_active === 1 ? "" : "Inactive"}
                          >
                            {row.accounttypecdshow}
                          </TableCell>

                          <TableCell
                            align="left"
                            title={row.is_active === 1 ? "" : "Inactive"}
                          >
                            {row.enteredtimestamps}
                          </TableCell>
                          <TableCell className="actionBackGround"  align="center" sx={{position :!showActions ? 'relative' : 'sticky'}}>
                            <Tooltip
                              title={
                                row.is_active == 1
                                  ? "Mark as Inactive"
                                  : "Mark as Active"
                              }
                              placement="left"
                              disableInteractive
                              arrow
                            >
                              <IconButton
                                onClick={(event) => {
                                  event.stopPropagation();
                                  if (Freeze == 1) {
                                    return handleFreeze();
                                  }
                                  if (row.restrictedflag) {
                                    return showErrorSnackbar(
                                      "Default Groups Cannot Be Set To Inactive"
                                    );
                                  }
                                  setActiveValueModal(row);
                                }}
                                aria-label="delete"
                                sx={{
                                  margin: "0px 2px",
                                  padding: "5px",
                                  // backgroundColor: "#FEF3C7",
                                  backgroundColor:"white"
                                }}
                              >
                                {row.is_active == 1 ?  (
                                  <CheckCircleOutline
                                    sx={{ fontSize: "15px", color: "green" }}
                                  />
                                ) : (
                                  <DoDisturbAlt
                                    sx={{ fontSize: "15px", color: "red" }}
                                  />
                                )}
                              </IconButton>
                            </Tooltip>
                            <Tooltip
                              title={"Delete"}
                              placement="right"
                              disableInteractive
                              arrow
                            >
                              <IconButton
                                onClick={(event) => {
                                  event.stopPropagation();
                                  if (Freeze == 1) {
                                    return handleFreeze();
                                  }
                                  setSelectedRow({ id: row.accountgroupid });
                                  setDeleteModal(true);
                                }}
                                aria-label="delete"
                                sx={{
                                  margin: "0px 2px",
                                  padding: "5px",
                                  // backgroundColor: "#fbc7c7",
                                  backgroundColor:"white"
                                }}
                              >
                                <Delete
                                  sx={{ fontSize: "15px", color: "#eb6a6a" }}
                                />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      );
                    })
                ) : circularOpen == false && allGroups.length == 0 ? (
                  <TableRow>
                    <TableCell align="center" colSpan={8}>
                      No Data Found
                    </TableCell>
                  </TableRow>
                ) : (
                  ""
                )}
                {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height: (dense ? 21 : 41) * emptyRows,
                    }}
                  >
                    <TableCell colSpan={9} />
                  </TableRow>
                )}
                {circularOpen == true &&
                  rowsPerPage > 0 &&
                  Array.from({ length: rowsPerPage }, (_, index) => (
                    <TableRow key={index}>
                      <TableCell colSpan={12}>
                        <Skeleton variant="text" sx={{ fontSize: "2rem" }} />
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>

          {rows.length > 0 && (
            <TablePagination
              rowsPerPageOptions={defaultRowsPerPageOptions}
              component="div"
              count={
                filteredList.filter((e) =>
                  ListSelection_fnForMasters(e, ListSelection)
                ).length
              }
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </Box>
      </Box>
      <DeleteLedgerGroup
        open={deleteModal}
        setOpen={setDeleteModal}
        setdeleteId={setdeleteId}
        selectedRow={selectedRow}
      />

      <DeleteSelectedGroup
        open={deleteSelectedModal}
        setOpen={setDeleteSelectedModal}
        partysData={selected}
        rows={rows}
        setSelected={setSelected}
        setRows={setRows}
      />
      <CreateAndEditGroupModal
        open={groupOpen}
        setOpen={setGroupOpen}
        groupId={null}
        action="create"
        setSelectedRow={setSelectedRow}
        setNewLedgerResponse={setNewId}
        page="groups"
        tab=""
        selectedRow={null}
        refetchGroupMaster={getGroupMaster}
      />
      {activeValueModal && (
        <ListingActive
          text={"group"}
          open={activeValueModal}
          editData={{ serialisactive: activeValueModal?.is_active }}
          setOpen={setActiveValueModal}
          action={() => {
            markAsInActive(activeValueModal);
          }}
        />
      )}
    </Box>
  );
}

export default AllGroups;
